import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { Configuration } from '../model/configuration'; // Asegúrate de la ruta correcta a tu interfaz

@Injectable({
  providedIn: 'root'
})
export class ConfigurationService {

  private configuration: Configuration | null = null;
  private configUrl = 'assets/config.json'; // Usa la ruta correcta a tu archivo

  constructor(private _http: HttpClient) { }

  loadConfig(): Observable<Configuration> {
    return this._http.get<Configuration>(this.configUrl).pipe(
      tap(config => this.configuration = config), // Almacena la configuración al cargarla
      catchError(error => {
        console.error('Error al cargar la configuración:', error);
        return of({} as Configuration); // Retorna un objeto vacío en caso de error
      })
    );
  }

  getConfiguration(): Configuration | null {
    return this.configuration;
  }
}